const DiskReg = /^[a-zA-Z]:/;
const EXTENSIONS = ['tar.gz', 'zip'];

export default class BrowseDialogUtils {
  constructor(osSeparator) {
    this.pathSeparator = osSeparator;
    this.isWindows = osSeparator === '\\';
  }

  getRootBreadcrumb(rootCount) {
    if (this.isWindows) {
      if (rootCount !== 1) {
        return [{name: 'Computer', path: '', exists: true}];
      }
    } else {
      return [{name: '/', path: '/', exists: true}];
    }
    return [];
  }

  cleanPathElements(pathArray) {
    return pathArray.map(n => {
      if (!/:\\/.test(n)) {
        return n.replace(this.pathSeparator, '');
      }
      return n;
    }).filter(n => n !== '');
  }

  getUnavailableDisk(serverPath, path) {
    if (this.isWindows && serverPath === '') {
      const pathParts = this.getPathParts(path);

      /**
       * No detecting if typed just part of path, 'F:' for example
       */
      if (pathParts.length < 2 && !this.endsWithSeparator(path)) {
        return;
      }

      const diskName = pathParts[0];
      if (this.windowsDisk(diskName)) {
        return diskName;
      }
    }
  }

  isFilePath(path) {
    return path && EXTENSIONS.some(extension => path.indexOf(extension) !== -1 && path.indexOf(extension) === path.length - extension.length);
  }

  addTrailingSlashIfNeeded(path) {
    if (path && !this.endsWithSeparator(path, this.pathSeparator) && !this.isFilePath(path)) {
      // eslint-disable-next-line no-param-reassign
      path += this.pathSeparator;
    }
    return path;
  }

  constructPathByParts(parts) {
    const firstSeparator = this.windowsDisk(parts[0]) ? this.pathSeparator : '';
    const visiblePath = parts[0] + firstSeparator + parts.slice(1).join(this.pathSeparator);
    return this.addTrailingSlashIfNeeded(visiblePath);
  }

  notAbsolutePath(response) {
    return !response.absolutePath && response.children.length === 0;
  }

  endsWithSeparator(path, separator = this.pathSeparator) {
    return path[path.length - 1] === separator;
  }

  getPathParts(path) {
    return this.cleanPathElements(path.split(this.pathSeparator));
  }

  windowsDisk(diskName) {
    return DiskReg.test(diskName);
  }

  isSameParts(clientPathPart, serverPathPart = '') {
    return serverPathPart.toLowerCase() === clientPathPart.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/blocks/browse-dialog/browse-dialog__utils.js